import DealerAddresses from "./DealerAddresses";

class DealerGeolocator {

    getCoordinates(location, countryCode){
        return new $.Deferred((dfd) => {
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                address: location,
                componentRestrictions: {
                    country: countryCode
                }
            },
            (results, status) => {
                if (status.toString() === google.maps.GeocoderStatus.OK) { // '3'
                    dfd.resolve(results[0].geometry.location);
                } else {
                    dfd.reject(new Error('Couldnt\'t find the location ' + location));
                }
            });
        });
    }


    filterByDistance(data, position, distance) {
        return data.filter(address => {
            let coordinates = DealerAddresses.toLatLng(address);
            return (DealerGeolocator.compareDistance(position, coordinates) / 1000) < distance;
        })
    }

    /**
     * Sort array of addresses by distance, compared to center (of map)
     *
     * @param {[{latitude: number, longitude: number}]} addresses
     * @param {{latitude: number, longitude: number}} mapCenter
     */
    sortByDistance(addresses, mapCenter) {

        // temporary array holds objects with position and sort-value
        let mapped = addresses.map((address, i) => {
            return {
                index: i,
                value: DealerGeolocator.compareDistance(
                    DealerAddresses.toLatLng(mapCenter),
                    DealerAddresses.toLatLng(address)
                )
            };
        });

        mapped.sort((a, b) => {
            return (a.value - b.value);
        });

        return mapped.map((el) => {
            return addresses[el.index];
        });

    }

    /** Filter data by country */
    filterByCountry(data, country) {
        return data.filter(address => {
            return (address.country === country);
        })
    }

    /**
     * Compare distance ...
     *
     * @param {google.maps.LatLng} coordinates1
     * @param {google.maps.LatLng} coordinates2
     * @returns {number}
     */
    static compareDistance (coordinates1, coordinates2) {
        return google.maps.geometry.spherical.computeDistanceBetween(coordinates1, coordinates2);
    }

    getPosition(){
        // Try HTML5 geolocation.
        // if (navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition(function(position) {
        //         var pos = {
        //             lat: position.coords.latitude,
        //             lng: position.coords.longitude
        //         };
        //
        //         map.setCenter(pos);
        //     }, function() {
        //         handleLocationError(true, infoWindow, map.getCenter());
        //     });
        // } else {
        //     // Browser doesn't support Geolocation
        //     handleLocationError(false, infoWindow, map.getCenter());
        // }

        // function handleLocationError(browserHasGeolocation, infoWindow, pos) {
        //     var infoWindow = new google.maps.InfoWindow({map: map});
        //
        //     infoWindow.setPosition(pos);
        //     infoWindow.setContent(browserHasGeolocation ?
        //         'Error: The Geolocation service failed.' :
        //         'Error: Your browser doesn\'t support geolocation.');
        // }
    }
}

export default DealerGeolocator;
